// extracted by mini-css-extract-plugin
export default {"topSection":"styles_topSection__4sbmt","title":"styles_title__R7lFq"};